import { VedleggFormData } from './vedlegg';

export const ONE_MEGABYTE = 1024 * 1024;
export const MAX_UPLOAD_SIZE = 25 * ONE_MEGABYTE;
export const MAX_FILE_SIZE = 4 * ONE_MEGABYTE;

export const toMB = (n: number): number => {
    return Math.round((n / 1024 ** 2) * 10) / 10;
};

export const getTotalFileSize = (vedleggFormData: VedleggFormData): number => {
    return vedleggFormData.vedlegg && toMB(vedleggFormData.vedlegg.reduce((total, current) => total + current.size, 0));
};
